export default __webpack_public_path__ + "static/media/T165_CoC.9aeb1420.pdf";